import { render, staticRenderFns } from "./Grundkosten.vue?vue&type=template&id=02ae6de2&"
import script from "./Grundkosten.vue?vue&type=script&lang=js&"
export * from "./Grundkosten.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports